var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',{staticClass:"table-row",class:{'table-row--parent': _vm.row[_vm.childDataKey]}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }